/** Segment track property: which SDK emitted the event (browser vs Gonfalon backend). */
export const EVENT_ORIGIN_KEY = 'eventOrigin' as const;

export const EVENT_ORIGIN_CLIENT = 'client' as const;

/** Possible values in payloads (client is set in the browser; server is set in Go only). */
export type EventOriginValue = typeof EVENT_ORIGIN_CLIENT | 'server';
